/**
 * Ordering's closed configuration vocabulary (ORDR-119, ruling B9).
 *
 * HARD-CODED from paio-shared `ConfigDomain` at ordering's pin `v3.22.0`, 19
 * members, in the enum's order. The GET refuses anything else with a 400, so
 * a member here that the service does not know means this pin drifted.
 */

export const CONFIG_DOMAINS = [
  "MENU_CONTENT",
  "MENU_STRUCTURE",
  "NUTRITION_ALLERGEN",
  "BASE_PRICE",
  "TAX_PROFILE",
  "PROMOTIONS",
  "LOYALTY_PROGRAMME",
  "BRAND_THEME",
  "FULFILMENT_MODES",
  "HOURS",
  "EIGHTYSIX",
  "CAPACITY",
  "PREP_TIMES",
  "STATION_ROUTING",
  "DELIVERY_ZONES",
  "DELIVERY_FEES",
  "COURIER_POLICY",
  "SETTLEMENT",
  "NOTIFICATION_TEMPLATES",
] as const;

export type ConfigDomain = (typeof CONFIG_DOMAINS)[number];

/**
 * The domains an ordering service actually READS, measured on paio-ordering
 * `e42b85a` (`ConfigDomain.<X>` outside tests, migrations and `authority.py`'s
 * preset lists). Every other domain is stored and served, and read by nobody.
 */
export const READ_BY_ORDERING: ReadonlySet<ConfigDomain> = new Set<ConfigDomain>([
  "CAPACITY",
  "COURIER_POLICY",
  "FULFILMENT_MODES",
  "HOURS",
  "PREP_TIMES",
]);

/**
 * The EDITABLE domains no ordering service reads (e42b85a). Saving one changes
 * nothing a diner sees, and the surface says so rather than letting a save look
 * like it did something.
 */
export const NO_ORDERING_READER: ReadonlySet<ConfigDomain> = new Set<ConfigDomain>([
  "STATION_ROUTING",
  "DELIVERY_ZONES",
  "DELIVERY_FEES",
]);
